export const projectCopyOperationToastId = (projectID: string): string =>
    `copy-op-${projectID}`;

export const projectCopySuccessToastId = (projectID: string): string =>
    `copy-success-${projectID}`;
